import { render, staticRenderFns } from "./ClientSelectorModal.vue?vue&type=template&id=586837b1&"
import script from "./ClientSelectorModal.vue?vue&type=script&lang=js&"
export * from "./ClientSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientSelectorModal.vue"
export default component.exports